import publicAxiosInstance from "../utils/API";

const addDemande = (payload) => {
    return publicAxiosInstance.post('/Demande/add', payload);
};
const getAllDemandes = () => {
    return publicAxiosInstance.get('/Demande/list');
};
const updateDemandeStatus = (demandeId, status, actorId) => {
    console.log('DemandeService PUT payload =', {status, actorId});
    return publicAxiosInstance.put(`/Demande/status/${demandeId}`, {status, actorId});
};

const CountDemandeEnAttente = (collaborateurId) => {
    return publicAxiosInstance.get("/Demande/count/en-attente", {
        params: {collaborateur: collaborateurId},
    });
};

const getDisabledDates = (collaborateurId) => {
    return publicAxiosInstance.get(`/Demande/disabled-dates/${collaborateurId}`);
};

const deleteDemande = (demandeId, actorId) => {
    return publicAxiosInstance.delete(`/Demande/delete/${demandeId}`, {
        data: { actorId }
    });
};
export {
    addDemande,
    getAllDemandes,
    updateDemandeStatus,
    CountDemandeEnAttente,
    getDisabledDates,
    deleteDemande
};

